



























































import DataTableInstallmentsSimple from '@/app/shared/components/data-tables/installments-simple.vue';
import { InstallmentModel } from '@/app/shared/models';
import { refsService } from '@/app/shared/refs.service';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({ components: { DataTableInstallmentsSimple } })
export default class DialogAllowanceComponent extends Vue {
  @Prop(Array) readonly data!: InstallmentModel[];

  private loading = false;
  private dialog = false;
  private valueTab = '';

  private get refs() {
    return refsService;
  }
  private get rules() {
    return this.refs.static.rules;
  }

  private async allowanceInstallment() {
    if (!this.valueTab) {
      this.$toast(this.$t('toasts.incomplete_or_invalid_fields'));
      return;
    }
    this.loading = true;
    const promises: Promise<void>[] = [];
    await this.data.forEach((installment) => {
      promises.push(
        this.refs.modules.contract.allowanceInstallment({
          contractId: this.refs.modules.contract.contract.Id,
          installmentId: installment.Id,
          descReason: this.valueTab,
        })
      );
    });
    Promise.all(promises)
      .then(async () => {
        this.refs.modules.ticket.SET_EDIT_INSTALLMENT_GENERATE(true);

        localStorage.removeItem('tabulacao');
        this.$bus.$emit('cleanValueTab');

        this.$toast(this.$t('toasts.allowance_installment_successfully'));
        await this.refs.modules.contract.loadInstallmentList(
          this.$route.params.id
        );
        this.dialog = false;
        this.$emit('uncheckInstallmentList');
      })
      .catch((err) => {
        this.$toast.error('ERROR ? ', err);
        this.$toast.error(this.$t('toasts.allowance_installment_error'));
      })
      .finally(() => (this.loading = false));
  }
  @Watch('dialog')
  private onChangeDialog() {
    this.valueTab = localStorage.getItem('tabulacao') ?? '';
  }
}
